/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ShippingDetailsQuotesTableRow_shipmentQuotes$ref = any;
export type ShippingDetailsQuotesTable_shipmentQuotes$ref = any;
export type ShippingDetailsQuotesTable_shipmentQuotes = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceMethod: {
                readonly region: {
                    readonly code: string | null;
                    readonly regionName: string | null;
                    readonly regionBoundary: {
                        readonly type: {
                            readonly name: string | null;
                        } | null;
                    } | null;
                } | null;
            } | null;
            readonly " $fragmentRefs": ShippingDetailsQuotesTableRow_shipmentQuotes$ref;
        } | null;
    } | null> | null;
    readonly " $refType": ShippingDetailsQuotesTable_shipmentQuotes$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ShippingDetailsQuotesTable_shipmentQuotes",
    "type": "ShipmentQuotesConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ShipmentQuotesEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "serviceMethod",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ShipmentServiceMethod",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "region",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Region",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "code",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "regionName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "regionBoundary",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "RegionBoundary",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "type",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "RegionBoundaryType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "name",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ShippingDetailsQuotesTableRow_shipmentQuotes",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'f67a8139a5bbabf55383a855ac8e3c1b';
export default node;
